module.exports = __webpack_public_path__ + "static/media/infoGray_icon.525a3993.svg";